import React from "react";
import { Stack, Typography, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

// scope: what the numbers cover — "All time", the date filter ("Last 30 days") or "Live".
export default function PanelHeading({ title, hint, action, scope }) {
  return (
    <Stack direction="row" alignItems="center" spacing={0.75} mb={1}>
      <Typography variant="subtitle1" fontWeight={700} sx={{ color: "#111827" }}>{title}</Typography>
      {hint && (
        <Tooltip title={hint} arrow placement="top">
          <InfoOutlinedIcon sx={{ fontSize: 15, color: "#9aa1ac", cursor: "help" }} />
        </Tooltip>
      )}
      {scope && (
        <Typography
          component="span"
          sx={{ fontSize: 11, fontWeight: 600, color: "#4B5563", background: "#F3F4F6", borderRadius: 999, px: 1, py: 0.25, whiteSpace: "nowrap" }}
        >
          {scope}
        </Typography>
      )}
      {action && <Stack direction="row" sx={{ ml: "auto" }}>{action}</Stack>}
    </Stack>
  );
}
